import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sevantinseaterbusrentalpune() {



const cardData =
  {
    keyword: '17 Seater Bus Rental Pune',
    heading: 'Sanavi Travels: 17 Seater Bus Rental Pune',
    headingDescription: 'Sanavi Travels offers reliable, comfortable, and affordable 17 Seater Bus Rental Pune for small to medium group travel requirements. Pune is a busy metropolitan city with frequent demand for compact group transportation from families, corporate teams, tourists, schools, and social groups. A 17 seater bus is the perfect solution when groups want to travel together without opting for large buses, ensuring easier maneuverability in city traffic, better coordination, and cost efficiency. Sanavi Travels provides well-maintained AC and Non-AC 17 seater buses with clean interiors, cushioned seating, proper ventilation, smooth suspension, and adequate luggage space, making them suitable for city travel as well as outstation journeys. Whether it is a wedding function, corporate meeting, picnic, school trip, family tour, or group outing, our 17 seater buses offer the right balance of comfort, safety, and affordability. With experienced drivers familiar with Pune city routes, highways, tourist destinations, and nearby towns, Sanavi Travels ensures punctual pickups, disciplined driving, and smooth travel experiences. Transparent pricing, flexible rental packages, and 24/7 customer support make 17 seater bus hire in Pune simple, stress-free, and dependable for every occasion.',

    top: 'Ideal Uses and Travel Routes for 17 Seater Bus Rental in Pune',


"topPlaces": [
  {
    "title": "City Travel Across Pune",
    "description": "A 17 seater bus is ideal for navigating Pune’s busy city roads while keeping the group together. Areas like Shivajinagar, Kothrud, Hadapsar, Baner, Wakad, Hinjewadi, Viman Nagar, and Kharadi are frequently covered using 17 seater buses for meetings, family functions, and local group travel, offering comfort without the bulk of large buses."
  },
  {
    "title": "Corporate and Office Travel",
    "description": "Corporate teams often prefer 17 seater buses for client visits, training programs, conferences, and team outings. The compact size allows smooth movement through IT parks and commercial areas while maintaining professional travel standards."
  },
  {
    "title": "Wedding and Family Functions",
    "description": "For weddings and social functions, 17 seater buses are commonly used to transport close relatives and family members between homes, hotels, temples, and venues. They help manage guest movement efficiently without overcrowding."
  },
  {
    "title": "Picnic and Leisure Trips",
    "description": "Schools, offices, and families frequently hire 17 seater buses for picnics and leisure trips around Pune. These buses provide comfortable seating, controlled travel, and cost-effective group transportation for short outings."
  },
  {
    "title": "Outstation Routes from Pune",
    "description": "Popular outstation destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Satara, and Mumbai are easily accessible with a 17 seater bus. The bus offers comfort for long journeys without the need for multiple cars."
  },
  {
    "title": "School and College Trips",
    "description": "Educational institutions prefer 17 seater buses for competitions, educational visits, and small group excursions, ensuring safe and organized student travel."
  },
  {
    "title": "Religious and Spiritual Tours",
    "description": "Families and groups traveling to temples and spiritual destinations often choose 17 seater buses for their manageable size, comfort, and ease of coordination."
  },
  {
    "title": "Airport and Railway Transfers",
    "description": "17 seater buses are suitable for group airport and railway station pickups and drops, allowing passengers and luggage to be transported together comfortably."
  },
  {
    "title": "Tourist Group Travel",
    "description": "Small tourist groups exploring Pune city or nearby attractions benefit from 17 seater bus rentals due to flexibility, convenience, and affordability."
  },
  {
    "title": "Family and Friends Group Tours",
    "description": "For family trips and friends’ getaways, a 17 seater bus ensures everyone travels together, enhancing the overall travel experience."
  }
]
,



"services": [
{
"name": "17 Seater Bus Rental Pune",
"description": "17 Seater Bus Rental Pune offers a perfect transportation solution for small to medium groups looking for comfort, safety, and affordability. These buses are well-maintained with clean interiors, cushioned seats, proper air circulation, and smooth suspension, making them suitable for city travel and long-distance routes. Sanavi Travels ensures professional drivers, punctual service, and flexible rental plans, making this service ideal for weddings, corporate travel, family tours, picnics, and outstation journeys."
},
{
"name": "17 Seater Bus Hire Pune",
"description": "17 Seater Bus Hire Pune provides dependable group travel options for events, office travel, and social functions. Hiring a single compact bus reduces coordination issues, fuel costs, and travel fatigue compared to multiple vehicles."
},
{
"name": "AC 17 Seater Bus on Rent Pune",
"description": "AC 17 Seater Bus on Rent Pune ensures a cool and comfortable journey, especially during summer months and long trips. Air-conditioned buses are preferred for weddings, corporate events, and premium group travel."
},
{
"name": "Non AC 17 Seater Bus Hire Pune",
"description": "Non AC 17 Seater Bus Hire Pune is a budget-friendly option for short trips, local travel, and economical group transportation while maintaining safety and reliability."
},
{
"name": "Luxury 17 Seater Bus Rental Pune",
"description": "Luxury 17 Seater Bus Rental Pune offers enhanced interiors, superior comfort, and a refined travel experience suitable for VIP guests, corporate executives, and special occasions."
},
{
"name": "Mini 17 Seater Bus Hire Pune",
"description": "Mini 17 Seater Bus Hire Pune is ideal for groups that require flexibility, easy city movement, and comfortable seating without opting for larger buses."
},
{
"name": "17 Seater Bus for Wedding Pune",
"description": "17 Seater Bus for Wedding Pune helps families manage close relatives and guests during wedding ceremonies, ensuring smooth and coordinated transportation."
},
{
"name": "17 Seater Bus for Corporate Travel Pune",
"description": "17 Seater Bus for Corporate Travel Pune supports office meetings, training programs, site visits, and team outings with professional and punctual service."
},
{
"name": "17 Seater Bus for Picnic Pune",
"description": "17 Seater Bus for Picnic Pune offers safe and enjoyable group travel for schools, offices, and families planning leisure outings."
},
{
"name": "17 Seater Bus for Outstation Pune",
"description": "17 Seater Bus for Outstation Pune provides reliable long-distance transportation to popular destinations, reducing travel stress and improving group coordination."
},
{
"name": "Affordable 17 Seater Bus Hire Pune",
"description": "Affordable 17 Seater Bus Hire Pune delivers cost-effective group travel solutions without compromising on vehicle condition or service quality."
},
{
"name": "Best 17 Seater Bus Service Pune",
"description": "Best 17 Seater Bus Service Pune is trusted for clean buses, experienced drivers, transparent pricing, and dependable service from Sanavi Travels."
},
{
"name": "17 Seater Bus Hire with Driver Pune",
"description": "17 Seater Bus Hire with Driver Pune provides chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules professionally."
},
{
"name": "17 Seater Bus for Family Trip Pune",
"description": "17 Seater Bus for Family Trip Pune ensures comfortable and relaxed travel for families planning tours, celebrations, or holidays together."
},
{
"name": "17 Seater Bus for Group Tour Pune",
"description": "17 Seater Bus for Group Tour Pune is ideal for friends, tourists, and small travel groups looking for convenient and enjoyable transportation."
}
],
"tableData": [
["17 Seater Bus Rental Pune", "17 Seater Bus Hire Pune"],
["AC 17 Seater Bus Pune", "Non AC 17 Seater Bus Pune"],
["Luxury 17 Seater Bus Pune", "Mini 17 Seater Bus Pune"],
["17 Seater Wedding Bus Pune", "17 Seater Corporate Bus Pune"],
["17 Seater Picnic Bus Pune", "17 Seater Family Bus Pune"],
["17 Seater Outstation Bus Pune", "17 Seater Bus with Driver Pune"],
["Affordable 17 Seater Bus Pune", "Best 17 Seater Bus Service Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "17 Seater Bus Rental Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides dependable and comfortable 17 seater bus services across Pune."
  },
  {
    "WhyChooseheading": "Perfect Size for Small Groups",
    "WhyChoosedescription": "Ideal for families, offices, and small tour groups."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Drivers are trained for city and highway travel."
  },
  {
    "WhyChooseheading": "Clean and Maintained Vehicles",
    "WhyChoosedescription": "Regularly serviced buses with clean interiors."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, daily, and outstation packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Travel",
    "WhyChoosedescription": "Buses are sanitized before every trip."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "Punctual pickups and smooth journey execution."
  }
]

}

const faqData = [
  {
    question: 'Do you provide 17 seater bus rental in Pune?',
    answer: 'Yes, Sanavi Travels offers 17 seater bus rental services across Pune.'
  },
  {
    question: 'Are AC and Non AC 17 seater buses available?',
    answer: 'Yes, both AC and Non AC 17 seater buses are available.'
  },
  {
    question: 'Can I hire a 17 seater bus for outstation travel?',
    answer: 'Yes, 17 seater buses are available for long-distance and outstation journeys.'
  },
  {
    question: 'Is a driver included with the bus?',
    answer: 'Yes, all 17 seater bus rentals include experienced drivers.'
  },
  {
    question: 'Are the buses cleaned and sanitized?',
    answer: 'Yes, buses are cleaned and sanitized before every trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nitin Deshpande',
    feedback: 'We hired a 17 seater bus in Pune for a family trip. Very comfortable and smooth journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Shah',
    feedback: 'Excellent 17 seater bus service for our office outing. Highly reliable.',
    rating: 5
  }
];

























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Bus Rental Pune - Sanavi Travels",
  "description": "Sanavi Travels offers 17 seater bus rental in Pune for weddings, corporate travel, picnics, outstation trips, family trips, and group tours. We provide AC and Non-AC 17 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | 17 Seater Bus Rental Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book 17 seater bus rental in Pune with Sanavi Travels. AC & Non-AC buses for weddings, corporate travel, picnics, outstation trips, family trips, and group tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/245.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sevantinseaterbusrentalpune;